import { Pipe, PipeTransform } from '@angular/core';

import { FormSection } from '@state/form';

@Pipe({
  name: 'formSectionName'
})
export class FormSectionNamePipe implements PipeTransform {
  transform(section: FormSection): string {
    return section.title || section.subtitle || `Section ${section.position + 1}`;
  }
}
